import type { SxProps, Theme } from '@mui/material/styles';

const indicationComparisonStyles = {
  titleSection: {
    p: 2,
    borderBottom: 1,
    borderColor: 'divider',
    flexShrink: 0
  },
  content: {
    flex: 1,
    overflowY: 'auto',
    p: 2
  },
  tableContainer: {
    mb: 2
  },
  tableHeaderRow: {
    bgcolor: 'grey.100'
  },
  tableHeaderCellField: {
    fontWeight: 700,
    width: '28%'
  },
  tableHeaderCellPrev: {
    fontWeight: 700,
    width: '36%'
  },
  tableHeaderCellCurr: {
    fontWeight: 700,
    width: '36%'
  },
  stubRow: {
    bgcolor: 'grey.50'
  },
  stubCell: {
    fontWeight: 600
  },
  studyPaper: {
    mb: 2,
    overflow: 'hidden',
    borderRadius: 1,
    borderColor: 'grey.300'
  },
  studyPaperHeader: {
    px: 2,
    py: 1,
    fontWeight: 700,
    bgcolor: 'grey.100',
    borderBottom: 1,
    borderColor: 'divider',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  studyRow: {
    '&:nth-of-type(even)': { bgcolor: 'grey.50' }
  },
  studyCellTh: {
    width: '28%',
    fontWeight: 600
  },
  studyCellPrev: {
    width: '36%'
  },
  studyCellCurr: {
    width: '36%'
  },
  actionsBar: {
    display: 'flex',
    justifyContent: 'center',
    gap: 2,
    p: 2,
    borderTop: 1,
    borderColor: 'divider',
    flexShrink: 0
  }
} as const satisfies Record<string, SxProps<Theme>>;

export default indicationComparisonStyles;
